import { Navigate } from 'react-router'

import { useRouteCompanyId } from '@/hooks/use-route-company-id'

export function CompanyParamRouteGuard({
  children,
}: {
  children: React.ReactNode
}) {
  const companyId = useRouteCompanyId()

  if (!companyId) {
    return <Navigate to="/companies" replace />
  }

  return children
}
